/**
 * Brazilian CPF validation and formatting utilities
 */

/**
 * Validate CPF number
 * @param {string} cpf - CPF to validate (with or without formatting)
 * @returns {boolean} - True if valid
 */
export const validateCPF = (cpf) => {
  // Remove non-numeric characters
  const cleaned = cpf.replace(/\D/g, '');
  
  // Must have 11 digits
  if (cleaned.length !== 11) {
    return false;
  }
  
  // Check for known invalid CPFs (all same digits)
  if (/^(\d)\1{10}$/.test(cleaned)) {
    return false;
  }
  
  // Validate first check digit
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleaned.charAt(i)) * (10 - i);
  }
  let remainder = sum % 11;
  let digit1 = remainder < 2 ? 0 : 11 - remainder;
  
  if (parseInt(cleaned.charAt(9)) !== digit1) {
    return false;
  }
  
  // Validate second check digit
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cleaned.charAt(i)) * (11 - i);
  }
  remainder = sum % 11;
  let digit2 = remainder < 2 ? 0 : 11 - remainder;
  
  if (parseInt(cleaned.charAt(10)) !== digit2) {
    return false;
  }
  
  return true;
};

/**
 * Format CPF as XXX.XXX.XXX-XX
 * @param {string} cpf - CPF to format
 * @returns {string} - Formatted CPF
 */
export const formatCPF = (cpf) => {
  const cleaned = cpf.replace(/\D/g, '');
  
  if (cleaned.length <= 3) {
    return cleaned;
  }
  if (cleaned.length <= 6) {
    return `${cleaned.slice(0, 3)}.${cleaned.slice(3)}`;
  }
  if (cleaned.length <= 9) {
    return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6)}`;
  }
  return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6, 9)}-${cleaned.slice(9, 11)}`;
};

/**
 * Remove formatting from CPF
 * @param {string} cpf - Formatted CPF
 * @returns {string} - CPF with only digits
 */
export const cleanCPF = (cpf) => {
  return cpf.replace(/\D/g, '');
};

export default {
  validateCPF,
  formatCPF,
  cleanCPF
};
